import { createRef } from 'react'
import { CustomRouteObject } from 'react-router-dom'

import { routeNamesPaths } from '@shared/constants'

export const ArbisoftPageRoute: CustomRouteObject = {
  path: routeNamesPaths.arbisoft,
  lazy: async () => {
    const { ArbisoftPage } = await import('./ui')

    return {
      Component: ArbisoftPage,
    }
  },
  nodeRef: createRef(),
}
